import { Avatar } from "./Avatar/Avatar";
import EstebanCaccinAvatar from "ProfilePictures/EstebanCaccin/steve.jpg";
import { ProfileInformation } from "./ProfileInformation/ProfileInformation";
import { estebanCaccin } from "Developers/EstebanCaccin/constants";
import { Projects } from "../Projects";
import { AuthContext } from "../AuthContext/AuthContext";
import { useContext, useEffect, useState } from "react";

import { LoginModal } from "./LoginModal/LoginModal";

import { Button } from "react-bootstrap";
import "./profile.scss";

export const Profile = () => {
  const { token, setToken } = useContext(AuthContext);

  const [isLoggedIn, setIsLoggedIn] = useState<string | boolean>(false);
  const [isOpenLoginModal, setIsOpenLoginModal] = useState<boolean>(false);
  const [isOpenProjects, setIsOpenProjects] = useState<boolean>(false);

  useEffect(() => {
    if (!token || token === "null") {
      setIsLoggedIn("notloggedin");
    } else {
      setIsLoggedIn("loggedin");
    }
    if (token.length > 5) {
      setIsLoggedIn("loggedin");
      setIsOpenProjects(true);
    } else {
      setToken("null");
    }
  }, [token]);

  return (
    <div className='d-flex justify-content-center align-items-center profile'>
      <Avatar
        className='ml-4'
        color='light-blue'
        avatar={EstebanCaccinAvatar}
      />
      <ProfileInformation
        className='dev-info-box ml-4 mt-3'
        profileInformation={estebanCaccin}
      />
      <Button
        className='projects-button'
        variant='light'
        size='sm'
        onClick={
          isLoggedIn === "loggedin"
            ? () => setIsOpenProjects(true)
            : () => setIsOpenLoginModal(true)
        }>
        Proyectos
      </Button>
      <Projects
        isOpenProjects={isOpenProjects}
        onCloseProjects={() => setIsOpenProjects(false)}
      />
      <LoginModal
        isOpenLoginModal={isOpenLoginModal}
        onCloseLoginModal={() => setIsOpenLoginModal(false)}
      />
    </div>
  );
};
